// Generated by CoffeeScript 2.7.0
export var sortAttachments = function(attachments) {
  var attachments_map;
  attachments_map = _.reduce(attachments, function(memo, attachment) {
    memo[attachment.id] = attachment;
    return memo;
  }, {});
  return _.chain(DomMaster.findAll('.attachment-item')).map(function(attachment_el) {
    return attachments_map[parseInt(attachment_el.data('attachment-id'))];
  }).compact().value();
};
